import React from 'react';
import { Button } from '../Button';
import { applyFilterButtonDataAttibute, clearFilterButtonDataAttribute } from './DataAttributes';
import styles from './styles.scss';
export var FilterActions = function FilterActions(_ref) {
  var disableApplyButton = _ref.disableApplyButton,
      onClearFilter = _ref.onClearFilter,
      onApplyFilter = _ref.onApplyFilter;
  return React.createElement("div", {
    className: styles.filterButtonsContainer
  }, React.createElement(Button, {
    size: "small",
    disabled: false,
    onClick: onClearFilter,
    dataTest: clearFilterButtonDataAttribute
  }, "Clear Filters"), React.createElement(Button, {
    dataTest: applyFilterButtonDataAttibute,
    disabled: disableApplyButton,
    onClick: onApplyFilter,
    size: "small",
    variant: "primary"
  }, "Apply"));
};
FilterActions.defaultProps = {
  disableApplyButton: false,
  onClearFilter: function onClearFilter() {},
  onApplyFilter: function onApplyFilter() {}
};